import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class PaymentsAPI {
  private static readonly API_URL = "/payments";

  static async getAllPayments(
    competitionId?: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.get(
          `${PaymentsAPI.API_URL}${
            competitionId ? `?competition_id=${competitionId}` : ""
          }`,
          true
        ),
      "Error al obtener los pagos"
    );
  }

  static async getPayment(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${PaymentsAPI.API_URL}/${id}`, true),
      "Error al obtener el pago"
    );
  }

  static async createPayment(data: {
    payment_id: number;
    sale_id: number;
    preference_id: string;
  }): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(PaymentsAPI.API_URL, data, true),
      "Error al crear el pago"
    );
  }

  static async getPaymentStatus(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${PaymentsAPI.API_URL}/${id}/status`, true),
      "Error al obtener el estado del pago"
    );
  }

  static async createTransferPayment(data: {
    comp_price_id: number;
    sender_first_name: string;
    sender_last_name: string;
    sender_cuit: string;
  }): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${PaymentsAPI.API_URL}/transfer`, data, true),
      "Error al crear el pago de transferencia"
    );
  }

  static async createTransferPaymentAdmin(data: {
    comp_price_id: number;
    sender_first_name: string;
    sender_last_name: string;
    sender_cuit: string;
    team_id: number;
    admin_notes?: string;
  }): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.post(`${PaymentsAPI.API_URL}/transfer/admin`, data, true),
      "Error al crear el pago de transferencia"
    );
  }

  static async confirmTransferPayment(
    transferId: number,
    data: {
      admin_notes?: string;
    }
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.patch(
          `${PaymentsAPI.API_URL}/transfer/${transferId}/confirm`,
          data,
          true
        ),
      "Error al confirmar el pago"
    );
  }

  static async rejectTransferPayment(
    transferId: number,
    data: {
      rejection_reason: string;
      admin_notes?: string;
    }
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.patch(
          `${PaymentsAPI.API_URL}/transfer/${transferId}/reject`,
          data,
          true
        ),
      "Error al rechazar el pago"
    );
  }

  static async getPendingTransfers(
    competitionId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.get(
          `${PaymentsAPI.API_URL}/transfer/pending?competition_id=${competitionId}`,
          true
        ),
      "Error al obtener las transferencias pendientes"
    );
  }

  static async createCashPayment(data: {
    payer_first_name: string;
    payer_last_name: string;
    payer_dni: string;
    comp_price_id: number;
    team_id: number;
  }): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${this.API_URL}/cash`, data, true),
      "Error al registrar el pago en efectivo"
    );
  }
}
